export default __webpack_public_path__ + "static/media/Rune Stone of the Warmonks.d4d0cc52.jpg";